import { TFunction } from 'i18next';
import { getOptionValidation } from '@lib/utils/validationUtils';
import { FieldItem } from '@lib/interfaces/form';
import { GetLoadOptions } from '@lib/components/Select/types';
import Select, { SelectProps } from '@lib/components/Select/Select';

type Args = {
  getChecklistsLoadOptions: GetLoadOptions;
  t: TFunction<'translation', undefined>;
};

export default function getFormFields({
  getChecklistsLoadOptions,
  t,
}: Args): FieldItem[] {
  return [
    {
      name: 'data',
      label: t('select-options-list-template'),
      element: Select,
      validation: getOptionValidation({ required: true, t }),
      componentProps: {
        defaultOptions: false,
        getLoadOptions: getChecklistsLoadOptions,
        isAsync: true,
        isClearable: false,
        isSearchable: false,
        menuPosition: 'fixed',
      } as SelectProps,
    },
  ];
}
